import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: ${(props) => props.theme.colors.white};
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 320px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

export const ModalHeader = styled.div`
  text-align: center;
  margin-bottom: 24px;

  h3 {
    font-size: 1.8rem;
    font-weight: 600;
    color: ${(props) => props.theme.colors.black};
    margin: 0;
  }
`;

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SelectLabel = styled.label`
  font-size: 1.4rem;
  font-weight: 500;
  color: ${(props) => props.theme.colors.contentLabelTxt};
`;

export const Select = styled.select`
  padding: 12px 16px;
  border: 1px solid ${(props) => props.theme.colors.mainBg};
  border-radius: 8px;
  font-size: 1.6rem;
  background: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.black};
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.primary};
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  gap: 12px;
`;

export const Button = styled.button<{ primary?: boolean }>`
  flex: 1;
  padding: 12px 16px;
  border: 1px solid
    ${(props) =>
      props.primary ? props.theme.colors.primary : props.theme.colors.mainBg};
  border-radius: 8px;
  font-size: 1.6rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  background: ${(props) =>
    props.primary ? props.theme.colors.primary : props.theme.colors.white};
  color: ${(props) =>
    props.primary ? props.theme.colors.white : props.theme.colors.black};

  &:hover {
    background: ${(props) =>
      props.primary ? props.theme.colors.primary : props.theme.colors.mainBg};
  }
`;
